var _defs, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_26186",
    "data-name": "Group 26186",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 153.885,
    height: 153.888,
    viewBox: "0 0 153.885 153.888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.074,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#d286ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#8a19ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#480971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#974dc4",
    stopOpacity: 0.635
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19311",
    "data-name": "Path 19311",
    d: "M76.942,0A76.944,76.944,0,1,1,0,76.944,76.943,76.943,0,0,1,76.942,0Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19311_-_Outline",
    "data-name": "Path 19311 - Outline",
    d: "M76.942,5.583A71.362,71.362,0,0,0,26.484,127.4,71.36,71.36,0,0,0,127.4,26.484a70.892,70.892,0,0,0-50.459-20.9m0-5.583A76.944,76.944,0,1,1,0,76.944,76.943,76.943,0,0,1,76.942,0Z",
    transform: "translate(0 0)",
    fill: "#ffd055"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "error",
    transform: "translate(33.831 50.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    "data-name": "Icon awesome-check",
    d: "M28.207,60.716,1.216,33.724a4.153,4.153,0,0,1,0-5.873l5.872-5.873a4.152,4.152,0,0,1,5.873,0L31.144,40.162,70.088,1.216a4.153,4.153,0,0,1,5.873,0l5.872,5.873a4.153,4.153,0,0,1,0,5.873L34.08,60.716A4.152,4.152,0,0,1,28.207,60.716Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralSelected);
export default __webpack_public_path__ + "static/media/general-selected.bfab7040a139c7d320107b9f5aceaab0.svg";
export { ForwardRef as ReactComponent };